import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'l-layout',
    standalone: true,
    templateUrl: './layout.component.html',
    imports: [
        NgIf,
        NgClass,
        FooterComponent
    ]
})
export class LayoutComponent {

  @Input()
  public fullscreen: boolean = false;

  @Input()
  public useBackground: boolean = false;

  @Input()
  public showFooter: boolean = true;

  @ViewChild('scrollContainer')
  private readonly scrollContainer?: ElementRef<HTMLElement>;

  public scrollToTop(): void {
    const container = this.scrollContainer?.nativeElement;

    if (container) {
      container.scrollTop = 0;
    }

    window.scrollTo(0, 0);
  }

}
